import React from 'react';
import { useHistory } from 'react-router-dom';
import chessslogo from '../../images/chessslogo.png';
import mansalva from '../../images/Mansalva/Mansalva-Regular.ttf';

const NativeAppLanding = () => {
  // Debug logging
  console.log('📱 NativeAppLanding component loaded');
  console.log('Window width:', window.innerWidth);
  console.log('window.Capacitor:', !!window.Capacitor);
  console.log('window.cordova:', !!window.cordova);
  console.log('User agent:', navigator.userAgent);
  
  const history = useHistory();

  const handleSignUp = () => {
    history.push('/signup');
  };

  const handleLogin = () => {
    history.push('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1a1a1a',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: '#ffffff',
      width: '100vw',
      paddingTop: 'env(safe-area-inset-top)',
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)',
      boxSizing: 'border-box'
    }}>
      {/* Font style declaration */}
      <style>
        {`
          @font-face {
            font-family: 'Mansalva';
            src: url(${mansalva}) format('truetype');
            font-weight: normal;
            font-style: normal;
          }
        `}
      </style>
      
      {/* Spacer to center content vertically */}
      <div style={{ flex: 1, minHeight: '20px' }} />
      
      {/* Logo */}
      <img 
        src={chessslogo} 
        alt="ChessThread" 
        style={{
          width: '150px',
          height: '150px',
          marginBottom: '30px'
        }}
      />
      
      {/* App Name */}
      <h1 style={{
        fontSize: '36px',
        fontFamily: 'Mansalva, cursive',
        fontWeight: 'normal',
        color: 'gold',
        margin: '0 0 20px 0',
        letterSpacing: '2px'
      }}>
        ChessThread
      </h1>

      {/* Tagline */}
      <p style={{
        fontSize: '20px',
        color: '#ccc',
        margin: '0 0 60px 0',
        textAlign: 'center',
        fontWeight: '300',
        fontFamily: 'Mansalva, cursive',
        letterSpacing: '2px'
      }}>
        Create, Learn, Contribute
      </p>

      {/* Action Buttons */}
      <div style={{
        width: '100%',
        maxWidth: '300px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <button
          onClick={handleSignUp}
          style={{
            width: '100%',
            padding: '18px',
            fontSize: '20px',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: 'gold',
            color: 'black',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
        >
          Sign Up
        </button>
        
        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '18px',
            fontSize: '20px',
            fontWeight: 'bold',
            border: '2px solid gold',
            borderRadius: '8px',
            backgroundColor: 'transparent',
            color: 'gold',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
        >
          Login
        </button>
      </div>
      
      {/* Bottom spacer to balance vertical centering */}
      <div style={{ flex: 1, minHeight: '20px' }} />
    </div>
  );
};

export default NativeAppLanding;